import React , {useState, useEffect} from 'react'

import { useSearchParams } from 'react-router-dom';
import { Document, Page } from 'react-pdf';
import '../../style-assets/pdf-css.scss';

const PDFViewers = () => {

    const [searchParams] = useSearchParams();
    const link = searchParams.get('link');


    const [numPages, setNumPages] = useState();
    const [screenSize, setScreenSize] = useState(getCurrentDimension());

    const onDocumentLoadSuccess = ({ numPages }) => {
      setNumPages(numPages);
    }
  

    function getCurrentDimension(){
    	return {
      		width: window.innerWidth,
      		height: window.innerHeight
    	}
  	}

    useEffect(() => {
      const updateDimension = () => {
        setScreenSize(getCurrentDimension())
      }
      window.addEventListener('resize', updateDimension);
      
      return(() => {
          window.removeEventListener('resize', updateDimension);
      })
    }, [screenSize])

    // Use the link from URL params if available, otherwise show message
    const pdfFile = link || null;

    if (!pdfFile) {
      return (
        <div className='pdf-section text-center py-5'>
          <p>No PDF file specified. Please provide a PDF link in the URL.</p>
        </div>
      );
    }

    return (
      <div className='pdf-section'>
      <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
       
       {
        Array.apply(null, Array(numPages))
        .map((x,i) => i + 1)
        .map((page) => {
          return (
            <Page 
              width={screenSize.width - 17}
              pageNumber={page}
              renderAnnotationLayer={false} 
              renderTextLayer={false}
            />
          )
        })
       }
      </Document>
    </div>
    )
   
}

export default PDFViewers